// AWS config
export const UserPoolId = `${process.env.REACT_APP_AWS_USER_POOL_ID}`;
export const ClientId = `${process.env.REACT_APP_AWS_CLIENT_ID}`;

// API endpoints and URL
/*export const API_URL = `${apiUrl}`*/
